import React, { useState, useMemo } from 'react';
import { filterRows } from './tableHelpers';
import { Pagination } from './Pagination';
import TableHead from "./TableHead";
import TableBody from "./TableBody";
import Button from "react-bootstrap/Button";
import {exportToExcel} from "../../helpers/ExportToExcel";


export const Table = ({ columns, state, checkRelatedItems, formHeader, relatedItemsUrl, getCompleteItem, tableClassName = "", tableContainerClassName = "", exportDataFactory = null, exportFileName = "export.xlsx" }) => {
  const [activePage, setActivePage] = useState(1);
  const [filters, setFilters] = useState({ });
  const [sort, setSort] = useState({ order: 'asc', orderBy: 'id' });
  const rowsPerPage = 20;
  const rows = state.itemsList;
//  const filteredRows = useMemo(() => filterRows(rows, filters), [rows, filters]);
  const filteredRows = useMemo(() => filterRows(rows, filters, columns), [rows, filters, columns]);
  const count = filteredRows.length;
  const totalPages = Math.ceil(count / rowsPerPage);
  const [selectedItems, setSelectedItems] = useState(new Set());




  const clearAll = () => {
    setSort({ order: 'asc', orderBy: 'id' });
    setActivePage(1);
    setFilters({ });
  }

  return (
    <>
      <div className={tableContainerClassName}>
      <table className={`table ${tableClassName}`.trim()}>
        <TableHead
          columns = { columns }
          setActivePage = { setActivePage }
          filters = { filters }
          setFilters = { setFilters }
          sort = { sort }
          setSort = { setSort }
          selectedItems={ selectedItems }
          setSelectedItems={ setSelectedItems }
          filteredRows={ filteredRows }
        />
        <TableBody
          columns = { columns }
          sort = { sort }
          activePage = { activePage }
          filteredRows = { filteredRows }
          rowsPerPage = { rowsPerPage }
          state = { state }
          formHeader = { formHeader }
          checkRelatedItems = { checkRelatedItems }
          relatedItemsUrl = { relatedItemsUrl }
          getCompleteItem = { getCompleteItem }
          setSelectedItems = { setSelectedItems }
          selectedItems = { selectedItems }
        />
      </table>
      </div>
      <div>
      { count > 0 ? (
        <Pagination
          activePage = { activePage }
          count = { count }
          rowsPerPage = { rowsPerPage }
          totalPages = { totalPages }
          setActivePage = { setActivePage }
        />
      ) : (
        <p>
          <span className={"err_info"}  style={{fontWeight: 600, marginRight: "10px"}}>Nie znaleziono danych spełniających kryteria wyszukiwania</span>

        </p>
      ) }

      <div>
        <p>
          <Button className = 'RAM_button' onClick = { clearAll }>Wyczyść filtry</Button>
          <Button className = 'RAM_button_LP10' onClick = { () => exportToExcel(exportDataFactory ? exportDataFactory(filteredRows, columns) : filteredRows, exportFileName) }>Eksport do Excela</Button>
        </p>
      </div>
      </div>

    </>
  )
}
